/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Anna drum search normalization.
 * Shopify full search currently omits the Medium-Small djembe for plain drum-related
 * queries, while the same query with a wildcard returns all five drum sizes.
 */
(function () {
  var rewrites = {
    "drum": "drum*",
    "djembe": "djembe*",
    "djembe drum": "djembe drum*",
    "hand drum": "hand drum*",
    "medium small drum": "medium small drum*",
    "medium-small drum": "medium small drum*"
  };

  function normalize(value) {
    return String(value || "").trim().toLowerCase().replace(/\s+/g, " ");
  }

  function rewrittenQuery(value) {
    return rewrites[normalize(value)] || value;
  }

  function ensureProductSearch(form) {
    if (form.querySelector('[name="type"]')) return;

    var typeInput = document.createElement("input");
    typeInput.type = "hidden";
    typeInput.name = "type";
    typeInput.value = "product";
    form.appendChild(typeInput);
  }

  document.addEventListener("submit", function (event) {
    var form = event.target && event.target.closest ? event.target.closest('form[action*="/search"]') : null;
    if (!form) return;

    var queryInput = form.querySelector('input[name="q"]');
    if (!queryInput) return;

    var nextValue = rewrittenQuery(queryInput.value);
    if (nextValue !== queryInput.value) {
      queryInput.value = nextValue;
      ensureProductSearch(form);
    }
  }, true);

  if (window.location.pathname === "/search") {
    var params = new URLSearchParams(window.location.search);
    var currentQuery = params.get("q");
    var nextQuery = rewrittenQuery(currentQuery);
    var needsProductType = currentQuery && !params.get("type") && Object.values(rewrites).indexOf(normalize(currentQuery)) !== -1;

    if (currentQuery && (nextQuery !== currentQuery || needsProductType)) {
      params.set("q", nextQuery);
      if (!params.get("type")) {
        params.set("type", "product");
      }
      window.location.replace(window.location.pathname + "?" + params.toString());
    }
  }
})();

